import styles from './styles.module.scss';
import { Img } from '../../';
import { FunctionComponent } from 'react';

export type CarouselThumbnailsProps = {
    activeIndex: number;
    img_urls: string[];
    onImgClick: (index: number) => void;
};

export const CarouselThumbnails: FunctionComponent<CarouselThumbnailsProps> = ({
    activeIndex = 0,
    img_urls = [],
    onImgClick,
}) => {
    if (!img_urls.length) return null;

    return (
        <div
            className={styles.thumbs_container}
            style={{ justifyContent: img_urls.length > 5 ? 'start' : 'center' }}
        >
            {img_urls.map((img, i) => {
                return (
                    <Img
                        src={img}
                        key={i}
                        alt={`Course image thumbnail ${i}`}
                        size="200"
                        className={styles.thumb}
                        onClick={() => onImgClick(i)}
                        style={{
                            opacity: activeIndex === i ? 1 : 0.5,
                        }}
                    />
                );
            })}
        </div>
    );
};
